import { Container, Row, Col } from "react-bootstrap";
import LaptopImg from "../assets/img/LaptopVisual.png";
import BadgeIcon from "../assets/img/BadgeIcon.svg";
import PackIcon from "../assets/img/PackIcon.svg";
import HealthcareIcon from "../assets/img/HealthcareIcon.svg";

export const ChooseUs = () => {
  return (
    <section className="choose" id="choose">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} xl={6}>
            <h1>
              Why{" "}
              <span style={{ color: "#306AFF" }}>
                <span className="pencilline2">Choose Us?</span>
              </span>
            </h1>
            <p>
              We think everyone{" "}
              <span style={{ color: "#306AFF" }}>deserves</span> access to the
              best medical treatment.
            </p>
            {/* Expertise */}
            <div className="chooseBox">
              <div className="chooseIcon">
                <img src={BadgeIcon} alt="BadgeIcon" />
              </div>
              <div className="chooseText">
                <p>
                  <span
                    style={{
                      color: "#306AFF",
                      fontSize: "20px",
                      fontWeight: "500",
                    }}
                  >
                    Expertise
                  </span>
                </p>
                <p>
                  Partner with a team of seasoned professionals dedicated to
                  ensuring your well-being.
                </p>
              </div>
            </div>
            {/* Tailored Packages */}
            <div className="chooseBox">
              <div className="chooseIcon">
                <img src={PackIcon} alt="PackIcon" />
              </div>
              <div className="chooseText">
                <p>
                  <span
                    style={{
                      color: "#306AFF",
                      fontSize: "20px",
                      fontWeight: "500",
                    }}
                  >
                    Tailored Packages
                  </span>
                </p>
                <p>
                  Our tailored packages cater specifically to the individual
                  needs of each international patient seeking medical treatment,
                  ensuring flexibility and personalized care.
                </p>
              </div>
            </div>
            {/* Healthcare for Everyone */}
            <div className="chooseBox">
              <div className="chooseIcon">
                <img src={HealthcareIcon} alt="HealthcareIcon" />
              </div>
              <div className="chooseText">
                <p>
                  <span
                    style={{
                      color: "#306AFF",
                      fontSize: "20px",
                      fontWeight: "500",
                    }}
                  >
                    Healthcare for Everyone
                  </span>
                </p>
                <p>
                  Our affordable service packages cater to everyone ensuring
                  accessibility for all and customization to individual needs.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} xl={6}>
            <img className="heroimage2" src={LaptopImg} alt="LaptopImg"></img>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
